<div class="container">
  <form (ngSubmit)="onSubmit()" (keyup.enter)="onSubmit()">
    <div class="form-group">
      <label for="email">Email</label>
      <input type="email" class="form-control" id="email" name="email" placeholder="Emailadresse" [(ngModel)]="email">
    </div>
    <div class="form-group">
      <label for="password">Passwort</label>
      <input type="password" id="password" name="password" class="form-control" placeholder="Passwort" [(ngModel)]="password">
    </div>
    <button type="submit" class="btn btn-primary">Login</button>
  </form>
</div>